
























import Vue from 'vue'
export default Vue.extend({
  mounted() {
    const observer = new IntersectionObserver(this.toggleClass, { rootMargin: '-20% 0px', threshold: 0 })
    Object.keys(this.$refs).forEach((key) => observer.observe(this.$refs[key] as HTMLElement))
  },
  methods: {
    toggleClass(entries: IntersectionObserverEntry[]) {
      entries.forEach((entry) => {
        const target = entry.target.querySelector('.block__heading') as HTMLElement
        entry.isIntersecting ? target.classList.add('is-animated') : target.classList.remove('is-animated')
      })
    }
  }
})
